
import { Link } from "react-router-dom";
import React, {useEffect, useState} from "react";
import { Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { categoryApi } from "../../api";


export default function Category2({onLoaded}) {

    const [categories, setCategories] = useState([]);

    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const { data } = await categoryApi.getCategories();
                setCategories(data.categories || []);
                onLoaded?.();
            } catch (error) {
            }
        };

        fetchCategories();
    }, []);

    return (
        <div className="flat-spacing-4">
            <div className="container">
                <div className="fl-control-sw pos1">
                    <Swiper
                        dir="ltr"
                        className="swiper tf-swiper hover-sw-nav wow fadeInUp"
                        {...{
                            slidesPerView: 2,
                            spaceBetween: 12,
                            speed: 800,
                            observer: true,
                            observeParents: true,
                            slidesPerGroup: 2,
                            navigation: {
                                clickable: true,
                                nextEl: ".nav-next-cls",
                                prevEl: ".nav-prev-cls",
                            },
                            pagination: { el: ".sw-pagination-cls", clickable: true },
                            breakpoints: {
                                768: { slidesPerView: 3, spaceBetween: 24, slidesPerGroup: 3 },
                                1200: { slidesPerView: 4, spaceBetween: 24, slidesPerGroup: 3 },
                            },
                        }}
                        modules={[Navigation, Pagination]}
                    >
                        {categories.map((category) => (
                            <SwiperSlide className="swiper-slide" key={category.slug}>
                                <div className="wg-cls style-abs2 hover-img">
                                    <Link to={`/product-list?category=${category.slug}`} className="image-wrap relative">
                                    <div className="image img-style">
                                            <img
                                                src={category.image}
                                                data-=""
                                                alt=""
                                                className="lazyload"
                                                width={696}
                                                height={696}
                                            />
                                        </div>
                                        <div className="cls-btn text-center">
                                            <button className="tf-btn btn-white hover-dark">
                                                View all
                                            </button>
                                        </div>
                                        <span className="tf-overlay" />
                                    </Link>
                                    <div className="cls-content text-center">
                                        <Link
                                            to={`/product-list?category=${category.slug}`}
                                            className="text-type text-xl-2 fw-medium link"
                                        >
                                            {category.name}
                                        </Link>
                                        <span className="count-item body-text-2 text-main">
                      {category.items}
                    </span>
                                    </div>
                                </div>
                            </SwiperSlide>
                        ))}
                        <div className="d-flex d-xl-none sw-dot-default sw-pagination-cls justify-content-center" />
                    </Swiper>
                    <div className="d-none d-xl-flex swiper-button-next nav-swiper nav-next-cls" />
                    <div className="d-none d-xl-flex swiper-button-prev nav-swiper nav-prev-cls" />
                </div>
            </div>
        </div>
    );
}
